import { useEffect, useState, useRef  } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import API from "../utils/api";
import socket from "../utils/socket";
import Swal from "sweetalert2";
const getMultiplierColor = (type) => {
  if (type === '2x') return '#FFD700';
  if (type === '3x') return '#FF6B6B';
  return '#FFD700';
};

const getMultiplierGlow = (type) => {
  if (type === '2x') return '0 0 30px rgba(255, 215, 0, 0.6)';
  if (type === '3x') return '0 0 30px rgba(255, 107, 107, 0.6)';
  return '0 0 30px rgba(255, 215, 0, 0.6)';
};

const MultiplierAnimation = ({ type }) => {
  const [scale, setScale] = useState(0.5);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    setScale(1);
    setOpacity(1);

    const timer = setTimeout(() => {
      setScale(0.85);
      setOpacity(0);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  // "3X" jaisa text banata hai type se, agar "3x" aaye to "3X" convert
  const label = type ? type.toUpperCase() : "";

  const badgeStyle = {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'linear-gradient(145deg, #fffdf5, #f3e9c9)',
    border: '4px solid transparent',
    borderImage: 'linear-gradient(145deg, #ffe27a, #b8860b, #ffe27a) 1',
    boxShadow: '0 0 20px rgba(255, 215, 0, 0.7), inset 0 0 8px rgba(184, 134, 11, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '26px',
    fontWeight: '900',
    color: '#3b0a45',
    fontFamily: 'serif',
    animation: 'multiplierPulse 0.6s ease-in-out infinite alternate',
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 99999,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '260px', // card ke dono side jitna gap chahiye, adjust kar sakte ho
        opacity: opacity,
        transition: 'opacity 0.5s ease-out',
      }}
    >
      <div
        style={{
          ...badgeStyle,
          transform: `scale(${scale}) translateX(0)`,
          transition: 'transform 0.3s ease-out',
        }}
      >
        {label}
      </div>
      <div
        style={{
          ...badgeStyle,
          transform: `scale(${scale}) translateX(0)`,
          transition: 'transform 0.3s ease-out',
          animationDelay: '0.3s',
        }}
      >
        {label}
      </div>

      <style>
        {`
          @keyframes multiplierPulse {
            0% { box-shadow: 0 0 20px rgba(255, 215, 0, 0.7), inset 0 0 8px rgba(184, 134, 11, 0.4); }
            100% { box-shadow: 0 0 32px rgba(255, 215, 0, 1), inset 0 0 12px rgba(184, 134, 11, 0.6); }
          }
        `}
      </style>
    </div>
  );
};

export default function HomePage() {
  const navigate = useNavigate();

  const [activeDraw, setActiveDraw] = useState(null);
  const [timeLeft, setTimeLeft] = useState("00:00");
  const [nextDrawTime, setNextDrawTime] = useState("");
  const [lastResultTime, setLastResultTime] = useState("");
  const [selectedBets, setSelectedBets] = useState({});
  const [totalPoints, setTotalPoints] = useState(0);
  const [lastResult, setLastResult] = useState(null);
  const [lastResultMultiplier, setLastResultMultiplier] = useState(1); // ← add this
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [user, setUser] = useState(null);
  const [moreDraws, setMoreDraws] = useState(0);
  const [history, setHistory] = useState([]);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  
  const [multiplier, setMultiplier] = useState(null);
const [showMultiplier, setShowMultiplier] = useState(false);
const [multiplierType, setMultiplierType] = useState(null); // '2x' or '3x'
const multiplierTimerRef = useRef(null);

  // Game status states
  const [isGameActive, setIsGameActive] = useState(true);
  const [gameStatusMessage, setGameStatusMessage] = useState("");
  const [nextActiveTime, setNextActiveTime] = useState(null);
  const [activePeriod, setActivePeriod] = useState(null);
const historyTimerRef = useRef(null);
const resultTimerRef = useRef(null);
const isFirstHistoryLoad = useRef(true);
const multiplierShownRef = useRef(false); // ← ADD THIS LINE

const isFirstResultLoad = useRef(true);

  // load animation script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/js/monkey-animation.js";
    script.async = true;

    script.onload = () => {
      console.log("Monkey animation loaded ✅");
    };

    document.body.appendChild(script);
  }, []);
  useEffect(() => {
  const handleEsc = (e) => {
    if (e.key === "Escape") {
      setShowResultPopup(false);
      setShowMultiplier(false); // ✅ ADD THIS LINE
    }
  };

  window.addEventListener("keydown", handleEsc);

  return () => window.removeEventListener("keydown", handleEsc);
}, []);
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/");
      return;
    }

    setUser(storedUser);
  }, []);
  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser?.user?._id) {
      if (!socket.connected) {
        socket.connect();
      }

      socket.emit("registerUser", storedUser.user._id);
    }

    return () => {
      socket.off("drawsUpdate");
      socket.off("drawResult");
      socket.off("balanceUpdate");
      socket.disconnect();
    };
  }, []);
  
  // fetch active draw
useEffect(() => {
  const fetchActiveDraw = async () => {
    try {
      const response = await API.get("/draws/active");
      setActiveDraw(response.data);
    } catch (err) {
      console.error("Error fetching active draw:", err);
  if (err.response?.status === 401) {
    // test if swal works at all
    alert("Session Timeout"); // ← add this temporarily
    Swal.fire({
      icon: 'error',
      title: 'Logged in other device',
      text: 'Please login again.',
      timer: 2000,
      showConfirmButton: false,
      // didClose: () => {
        // localStorage.removeItem("user");
        // window.location.href = "/";
      // }
    });
  }
    }
  };

  fetchActiveDraw();
}, []);
  

  
  // socket listeners
  useEffect(() => {
    socket.on("drawsUpdate", (data) => {
      // Update game status
      setIsGameActive(data.isGameActive);
      
      if (data.message) {
        setGameStatusMessage(data.message);
      }
      
      if (data.activePeriod) {
        setActivePeriod(data.activePeriod);
      }
      
      if (data.nextActiveTime) {
        setNextActiveTime(data.nextActiveTime);
      }
      
      // Update active draw and timer
      if (data.isGameActive && data.activeDraw) {
        setActiveDraw(data.activeDraw);

        if (data.activeDraw) {
          const now = new Date(data.currentTime);
          const end = new Date(data.activeDraw.endTime);

          const diff = Math.max(0, end - now);
          const sec = Math.floor(diff / 1000);

          const min = Math.floor(sec / 60);
          const s = sec % 60;

          setTimeLeft(`${min}:${s < 10 ? "0" : ""}${s}`);
          const endTime = new Date(data.activeDraw.endTime);
          const formattedTime = endTime.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          setNextDrawTime(formattedTime);
        }
      } else if (!data.isGameActive && data.nextActiveFormatted) {
        setNextDrawTime(data.nextActiveFormatted);
        
        // Update countdown timer
        if (data.nextActiveTime) {
          const nextActive = new Date(data.nextActiveTime);
          const now = new Date(data.currentTime);
          const diff = Math.max(0, nextActive - now);
          
          const hours = Math.floor(diff / (1000 * 60 * 60));
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);
          
          setTimeLeft(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }
      }

      // SET HISTORY (RIGHT PANEL)
if (data.recentResults) {
  // FIRST TIME → show immediately
  if (isFirstHistoryLoad.current) {
    setHistory(data.recentResults);
    isFirstHistoryLoad.current = false;
  } else {
    // NEXT TIMES → delay
 if (data.recentResults) {
  if (isFirstHistoryLoad.current) {
    setHistory(data.recentResults);
    isFirstHistoryLoad.current = false;
  } else {
    if (!historyTimerRef.current) {
      historyTimerRef.current = setTimeout(() => {
        setHistory(data.recentResults);
        historyTimerRef.current = null;
      }, 6000);
    }
  }
}

    historyTimerRef.current = setTimeout(() => {
      setHistory(data.recentResults);
    }, 6000);

    // ✅ CENTER CARD (INITIAL LOAD / REFRESH)
if (data.lastResult?.result?.card) {
  setLastResult(data.lastResult.result.card);
  setLastResultMultiplier(data.lastResult.multiplier ?? 1); // ← add this

  if (data.lastResult.result?.declaredAt) {
    const declaredTime = new Date(data.lastResult.result.declaredAt);
    const formattedDeclaredTime = declaredTime.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    setLastResultTime(formattedDeclaredTime);
  }
}
  }
}


    });
    
    socket.on("balanceUpdate", (data) => {
      console.log("💰 balanceUpdate:", data);

      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (!storedUser) return;

      const updatedUser = {
        ...storedUser,
        user: {
          ...storedUser.user,
          wallet_balance: data.wallet_balance,
          win_balance: data.win_balance,
        },
      };

      localStorage.setItem("user", JSON.stringify(updatedUser));
      setUser(updatedUser);
    });

socket.on("drawResult", (data) => {
  const result = data.result;

  if (resultTimerRef.current) return;

  resultTimerRef.current = setTimeout(() => {
    setLastResult(result);

    const now = new Date();
    const formattedTime = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    setLastResultTime(formattedTime);
    resultTimerRef.current = null;

    // ✅ MULTIPLIER — ab wheel animation khatam hone ke BAAD (result ke saath) dikhega
    if (data.multiplier && data.multiplier > 1 && !multiplierShownRef.current) {
      multiplierShownRef.current = true;

      const multiplierText = `${data.multiplier}x`;
      setMultiplierType(multiplierText);
      setShowMultiplier(true);

      if (multiplierTimerRef.current) {
        clearTimeout(multiplierTimerRef.current);
      }

      multiplierTimerRef.current = setTimeout(() => {
        setShowMultiplier(false);
        setMultiplierType(null);
        multiplierTimerRef.current = null;
        multiplierShownRef.current = false;
      }, 3000);
    }
  }, 6000);

  const segmentMap = {
    "J-Clubs": 0,
    "J-Diamonds": 1,
    "J-Hearts": 2,
    "J-Spades": 3,
    "Q-Clubs": 4,
    "Q-Diamonds": 5,
    "Q-Hearts": 6,
    "Q-Spades": 7,
    "K-Clubs": 8,
    "K-Diamonds": 9,
    "K-Hearts": 10,
    "K-Spades": 11,
  };

  const winningSegment = segmentMap[result];
  console.log("🚀 ~ HomePage ~ winningSegment:", winningSegment);

  if (window.startDrawAnimation && winningSegment !== undefined) {
    window.startDrawAnimation({
      winningSegment: winningSegment,
    });
  } else {
    console.error("Invalid card result:", result);
  }
});

return () => {
  socket.off("drawsUpdate");
  socket.off("drawResult");
  socket.off("balanceUpdate");
  if (multiplierTimerRef.current) {
    clearTimeout(multiplierTimerRef.current);
    multiplierTimerRef.current = null;
  }
  multiplierShownRef.current = false; // Reset flag on cleanup
};
  }, []);
  
  const toast = (icon, title) => {
    Swal.fire({
      toast: true,
      position: "top-start",
      icon,
      title,
      showConfirmButton: false,
      timer: 2000,
    });
  };
  
  // handle bet input
  const handleBetChange = (card, value) => {
    if (!isGameActive) {
      toast("warning", "Game is currently inactive");
      return;
    }
    const amount = Number(value);

    setSelectedBets((prev) => {
      const updated = { ...prev, [card]: amount };

      const total = Object.values(updated).reduce((a, b) => a + (b || 0), 0);
      setTotalPoints(total);

      return updated;
    });
  };
  
// Pre-load the sound once for better performance
let coinSound = null;

// Initialize sound on user interaction (required by browsers)
const initCoinSound = () => {
  if (!coinSound) {
    coinSound = new Audio('/sounds/coin.mp3');
    coinSound.load();
    coinSound.volume = 0.3;
  }
};
// Multiplier Animation Component

// Play single coin sound
const playCoinSound = (pitch = 1) => {
  if (!coinSound) {
    initCoinSound();
  }
  
  // Clone the audio to allow overlapping sounds
  const sound = coinSound.cloneNode();
  sound.volume = 0.25 + (Math.random() * 0.15);
  sound.playbackRate = 0.9 + (Math.random() * 0.2); // Random pitch variation
  
  sound.play().catch(e => {
    console.warn('Audio play failed:', e);
    // Fallback to web audio if needed
    fallbackCoinSound();
  });
};

// Play multiple coins with natural spacing
const playMultipleCoinSounds = (count = 8) => {
  for (let i = 0; i < count; i++) {
    setTimeout(() => {
      if (!coinSound) {
        initCoinSound();
      }
      
      const sound = coinSound.cloneNode();
      // Each coin has slightly different volume and pitch
      sound.volume = 0.2 + (Math.random() * 0.2);
      sound.playbackRate = 0.85 + (Math.random() * 0.3);
      
      sound.play().catch(e => console.warn('Audio play failed:', e));
    }, i * 100); // 100ms gap between coins
  }
};

// Fallback in case audio file fails to load
const fallbackCoinSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const now = ctx.currentTime;
    
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.exponentialRampToValueAtTime(1200, now + 0.05);
    osc.frequency.exponentialRampToValueAtTime(600, now + 0.15);
    
    osc.connect(gain);
    gain.connect(ctx.destination);
    
    gain.gain.setValueAtTime(0.3, now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);
    
    osc.start(now);
    osc.stop(now + 0.25);
    
    setTimeout(() => ctx.close(), 300);
  } catch (e) {
    console.warn('Fallback audio failed:', e);
  }
};

// Enhanced coin sound with metallic effect
const playRealisticCoinSound = () => {
  if (!coinSound) {
    initCoinSound();
  }
  
  // Create a quick metallic ring using Web Audio for better effect
  const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  const now = audioCtx.currentTime;
  
  // Metallic ring
  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();
  const filter = audioCtx.createBiquadFilter();
  
  osc.type = 'sine';
  osc.frequency.setValueAtTime(3200, now);
  osc.frequency.exponentialRampToValueAtTime(1800, now + 0.08);
  
  filter.type = 'bandpass';
  filter.frequency.value = 4000;
  filter.Q.value = 8;
  
  osc.connect(filter);
  filter.connect(gain);
  gain.connect(audioCtx.destination);
  
  gain.gain.setValueAtTime(0, now);
  gain.gain.linearRampToValueAtTime(0.25, now + 0.003);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);
  
  osc.start(now);
  osc.stop(now + 0.15);
  
  // Play the actual coin sound file after the metallic ring
  setTimeout(() => {
    const sound = coinSound.cloneNode();
    sound.volume = 0.3;
    sound.play().catch(e => console.warn('Audio play failed:', e));
  }, 50);
  
  setTimeout(() => audioCtx.close(), 200);
};

// Main function to handle point transfer with coin animation and sound
const handleTakePoints = async () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) return navigate("/");

    const winPointsEl = document.querySelector('.win-points span');
    const availPointsEl = document.querySelector('.available-point');
    const btn = document.querySelector('.take-point-btn');
    
    let winPts = parseInt(winPointsEl.textContent.replace(/\D/g, '')) || 0;
    if (winPts <= 0) {
      toast("info", "No win points to transfer");
      return;
    }
    
    let availMatch = availPointsEl.textContent.match(/[\d]+/);
    let availPts = availMatch ? parseInt(availMatch[0]) : 0;
    
    if (btn) btn.disabled = true;
    
    const numCoins = Math.min(winPts, 12); // Max 12 coins for animation
    
    // Play multiple coin sounds based on number of coins
    playMultipleCoinSounds(numCoins);
    
    // Animate coins flying to wallet
    for (let i = 0; i < numCoins; i++) {
      setTimeout(() => {
        const coin = document.createElement('div');
        coin.textContent = '💰';
        Object.assign(coin.style, {
          position: 'fixed',
          width: '32px', height: '32px',
          borderRadius: '50%',
          background: 'radial-gradient(circle at 35% 35%, #ffd966, #ffaa00)',
          border: '2px solid #ffcc33',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '18px', fontWeight: '700',
          zIndex: '9999',
          pointerEvents: 'none',
          transition: 'transform 0.6s cubic-bezier(0.34, 1.2, 0.64, 1), opacity 0.4s ease',
          left: btn ? btn.getBoundingClientRect().left + 'px' : '50%',
          top: btn ? btn.getBoundingClientRect().top + 'px' : '50%',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        });
        document.body.appendChild(coin);
        
        const target = availPointsEl.getBoundingClientRect();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            coin.style.transform = `translate(${target.left - (btn ? btn.getBoundingClientRect().left : 0)}px, ${target.top - (btn ? btn.getBoundingClientRect().top : 0)}px) scale(0.5)`;
            coin.style.opacity = '0';
          });
        });
        
        setTimeout(() => {
          coin.remove();
        }, 650);
      }, i * 80);
    }
    
    // Make API call after animation starts
    setTimeout(async () => {
      try {
        const res = await API.post("/auth/transfer-win", {
          userId: storedUser.user._id,
        });
        
        const updatedUser = {
          ...storedUser,
          user: {
            ...storedUser.user,
            wallet_balance: res.data.wallet_balance,
            win_balance: res.data.win_balance,
          },
        };
        
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setUser(updatedUser);
        
        // Update UI
        if (winPointsEl) winPointsEl.textContent = `Win Points : 0`;
        if (availPointsEl) {
          const newBalance = res.data.wallet_balance;
          availPointsEl.innerHTML = availPointsEl.innerHTML.replace(/[\d]+/, newBalance);
        }
        
        toast("success", `${winPts} points transferred successfully!`);
        
        // Success flash on button
        if (btn) {
          btn.style.background = '#4caf50';
          btn.style.color = '#fff';
          setTimeout(() => {
            btn.style.background = '';
            btn.style.color = '';
            btn.disabled = false;
          }, 800);
        }
      } catch (err) {
        toast("error", err.response?.data?.error || "Transfer failed");
        if (btn) btn.disabled = false;
      }
    }, 500);
    
  } catch (err) {
    console.error('Error in handleTakePoints:', err);
    toast("error", "Something went wrong");
  }
};

// Initialize sound on first user interaction
document.addEventListener('click', function initAudio() {
  initCoinSound();
  document.removeEventListener('click', initAudio);
}, { once: true });
  
  const placeMultiBet = async () => {
    try {
      if (!isGameActive) {
        toast("warning", "Game is currently inactive");
        return;
      }
      
      if (!activeDraw) return toast("error", "No active draw");

      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (!storedUser) return navigate("/");

      const numbers = Object.entries(selectedBets)
        .filter(([_, val]) => val > 0)
        .map(([card, amount]) => ({ card, amount }));

      if (!numbers.length) {
        return toast("warning", "Enter bets first");
      }

      if (moreDraws <= 0) {
        return toast("warning", "Please select number of draws");
      }

      if (moreDraws > 10) {
        return toast("error", "Max 10 draws allowed");
      }

      // For multi bet
try {
   const res = await API.post("/bets/multi", {
        drawId: activeDraw._id,
        userId: storedUser.user._id,
        points: totalPoints,
        numbers,
        drawCount: moreDraws,
      });
  
  // Handle success
  toast.success("Bet placed successfully");
  
} catch (err) {
  console.error("Error placing multi bet:", err);
  if (err.response?.status === 401) {
        alert("Logged in other device"); // ← add this temporarily

    // localStorage.removeItem("user");
    // window.location.href = "/";
    toast("error", "Session expired. Please log in again.");
  }
   
}


      toast("success", `Bet placed for ${moreDraws} draws`);

      setSelectedBets({});
      setTotalPoints(0);
      setSelectedCoin(null);
      setMoreDraws(0);

    } catch (err) {
      toast("error", err.response?.data?.error || "Multi bet failed");
    }
  };
  
  const handleCardClick = (card) => {
    if (!isGameActive) {
      toast("warning", "Game is currently inactive");
      return;
    }
    if (!selectedCoin) return;

    setSelectedBets((prev) => {
      const current = prev[card] || 0;
      const updatedValue = current + selectedCoin;

      const updated = {
        ...prev,
        [card]: updatedValue,
      };

      const total = Object.values(updated).reduce((a, b) => a + (b || 0), 0);
      setTotalPoints(total);

      return updated;
    });
  };
  
  const handleColumnAll = (colIndex) => {
    if (!isGameActive) {
      toast("warning", "Game is currently inactive");
      return;
    }
    if (!selectedCoin) return;

    const rows = [
      ["K-Clubs.png", "K-Diamonds.png", "K-Spades.png", "K-Hearts.png"],
      ["Q-Clubs.png", "Q-Diamonds.png", "Q-Spades.png", "Q-Hearts.png"],
      ["J-Clubs.png", "J-Diamonds.png", "J-Spades.png", "J-Hearts.png"],
    ];

    setSelectedBets((prev) => {
      const updated = { ...prev };

      rows.forEach((row) => {
        const card = row[colIndex].replace(".png", "");
        updated[card] = (updated[card] || 0) + selectedCoin;
      });

      const total = Object.values(updated).reduce((a, b) => a + (b || 0), 0);
      setTotalPoints(total);

      return updated;
    });
  };
  
  const handleRowAll = (row) => {
    if (!isGameActive) {
      toast("warning", "Game is currently inactive");
      return;
    }
    if (!selectedCoin) return;

    setSelectedBets((prev) => {
      const updated = { ...prev };

      row.forEach((img) => {
        const card = img.replace(".png", "");
        updated[card] = (updated[card] || 0) + selectedCoin;
      });

      const total = Object.values(updated).reduce((a, b) => a + (b || 0), 0);
      setTotalPoints(total);

      return updated;
    });
  };
  
  const handleClearBets = () => {
    setSelectedBets({});
    setTotalPoints(0);
    setMoreDraws(0);
    setSelectedCoin(null);
  };

  const fetchResults = async () => {
    try {
      const res = await API.get("/results", {
        params: { fromDate, toDate },
      });
      setResultList(res.data.results || []);
    } catch (err) {
      toast("error", "Failed to fetch results");
    }
  };

  const openResults = async () => {
    setShowResultPopup(true);
    await fetchResults();
  };
  
  const placeBet = async () => {
    try {
      if (!isGameActive) {
        toast("warning", "Game is currently inactive");
        return;
      }
      
      if (!activeDraw) return toast("error", "No active draw");

      const storedUser = JSON.parse(localStorage.getItem("user"));

      if (!storedUser) {
        navigate("/");
        return;
      }

      const numbers = Object.entries(selectedBets)
        .filter(([_, val]) => val > 0)
        .map(([card, amount]) => ({
          card,
          amount,
        }));

      if (!numbers.length) {
        return toast("warning", "Enter bets first");
      }
      
      try {
const res = await API.post("/bets", {
        drawId: activeDraw._id,
        userId: storedUser?.user?.username,
        points: totalPoints,
        numbers,
      });
  
  // Handle success
const updatedUser = {
        ...storedUser,
        user: {
          ...storedUser.user,
          wallet_balance: storedUser.user.wallet_balance - totalPoints,
        },
      };

      localStorage.setItem("user", JSON.stringify(updatedUser));
      setUser(updatedUser);

      toast("success", "Bet placed");

      setSelectedBets({});
      setTotalPoints(0);
      setSelectedCoin(null);  
} catch (err) {
  console.error("Error placing bet:", err);
  if (err.response?.status === 401) {
    // localStorage.removeItem("user");
    // window.location.href = "/";
  }
  // } else {
  //   toast.error(err.response?.data?.error || "Failed to place bet");
  // }
}
      

    } catch (err) {
      console.error("Error in placeBet:", err);
      toast("error", err.response?.data?.error || "Bet failed");
    }
  };

  // Get timer display text
  const getTimerDisplay = () => {
    if (!isGameActive) {
      return timeLeft;
    }
    return timeLeft;
  };

  const getTimerLabel = () => {
    if (!isGameActive) {
      return "Resumes In";
    }
    return "Time Left";
  };

  return (
    <section className="home-page">
      {/* HEADER */}
      <header className="header">
        <div className="header-left">
          <div className="termial-id">User Id : {user?.user?.username}</div>
          <div className="next-draw-time">Next Draw Time</div>
          <div className="Time">{nextDrawTime || "--:--"}</div>
        </div>

        <div className="header-center"></div>

        <div className="header-right">
          <div className="available-point">
            Available-point :- {user?.user?.wallet_balance ?? 0}
            {/* <a href="/after-login" className="close-btn">
  &times;
</a> */}
          </div>

          <div className="win-points">
            <span>Win Points : {user?.user?.win_balance ?? 0}</span>
            <button className="take-point-btn" onClick={handleTakePoints}>
              Take Points
            </button>{" "}
          </div>
        </div>
      </header>

      {/* MAIN */}
      <main className="main-content">
        <section className="main-left-section">
          {/* Inactive indicator - small text at top */}
          {!isGameActive && (
            <div className="inactive-indicator">
              <div className="inactive-text">
                ⏸️ Game Inactive • {gameStatusMessage || `Resumes at ${nextDrawTime}`}
              </div>
            </div>
          )}
          
          {/* ... rest of left section content remains the same ... */}
          <>
            {[
              ["K-Clubs.png", "K-Diamonds.png", "K-Spades.png", "K-Hearts.png"],
              ["Q-Clubs.png", "Q-Diamonds.png", "Q-Spades.png", "Q-Hearts.png"],
              ["J-Clubs.png", "J-Diamonds.png", "J-Spades.png", "J-Hearts.png"],
            ].map((row, rowIndex) => (
              <div key={rowIndex} className="card-row">
                {row.map((img, i) => (
                  <div
                    className={`card-box ${!isGameActive ? "disabled" : ""}`}
                    key={`${rowIndex}-${i}`}
                    onClick={() => handleCardClick(img.replace(".png", ""))}
                  >
                    <img
                      src={`/img/cards/${img}`}
                      className="card-img"
                      alt=""
                    />
                    <input
                      type="number"
                      className="card-input"
                      readOnly
                      disabled={!isGameActive}
                      value={selectedBets[img.replace(".png", "")] || ""}
                      onChange={(e) =>
                        handleBetChange(img.replace(".png", ""), e.target.value)
                      }
                    />
                  </div>
                ))}

                <div className="all-bet-box">
                  <button
                    className="all-bets-btn"
                    onClick={() => handleRowAll(row)}
                    disabled={!isGameActive}
                  >
                    All
                  </button>
                </div>
              </div>
            ))}

            <div className="card-row">
              {[0, 1, 2, 3].map((_, i) => (
                <div className="all-bet-box" key={i}>
                  <button
                    className="all-bets-btn"
                    onClick={() => handleColumnAll(i)}
                    disabled={!isGameActive}
                  >
                    All
                  </button>
                </div>
              ))}
            </div>
          </>
        </section>

        {/* CENTER - Modified section */}
        <section className="main-center-section">
          <div className="last-result-box">
            <div className="re-timing">
              {getTimerDisplay()}
            </div>

            <div className="last-result">
            <div className="last-result-img-x">
              <div className="last-result-img-x-box">{lastResultMultiplier ?? 1}X</div>
                {lastResult ? (
                  <img src={`/img/cards/${lastResult}.png`} alt="" />
                ) : (
                "LOADING..."
                )}
                <div className="last-result-img-x-box">{lastResultMultiplier ?? 1}X</div>

            </div>
              <span>Last Result</span>
            </div>

            <div className="re-timing">{lastResultTime || "--"}</div>
          </div>
        </section>

        {/* RIGHT section remains the same */}
        <section className="main-right-section">
          <div className="result-grid">
            {[...history]
              .sort((a, b) => new Date(a.endTime) - new Date(b.endTime))
              .map((draw, i) => {
                const card = draw?.result?.card;

                if (!card) return null;

                const [rank, suit] = card.split("-");
                
                const getSuitColor = (suit) => {
                  const suitColors = {
                    'Hearts': '#ff0000',
                    'Diamonds': '#ff0000',
                    'Spades': '#000000',
                    'Clubs': '#000000'
                  };
                  return suitColors[suit] || '#000000';
                };

                return (
                  <div className="result-box" key={i}>
                    <div className="result-circle">
                      <span style={{ color: getSuitColor(suit) }}>{rank}</span>
                      <img src={`/img/cards/${suit}.png`} alt="" />
                    </div>
                    <div className="result-time">
                      {new Date(draw.endTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </div>
                );
              })}
          </div>
        </section>
      </main>

      {/* BET ROW */}
      <div className="bet-row">
        {[5, 10, 20, 50, 100, 500].map((val) => (
          <button
            key={val}
            className={`bet-coin coin${val} ${selectedCoin === val ? "active" : ""} ${!isGameActive ? "disabled" : ""}`}
            onClick={() => setSelectedCoin(val)}
            disabled={!isGameActive}
          >
            {val}
          </button>
        ))}
      </div>

      {/* BOTTOM */}
      <div className="bottom-row">
        <button className="btn-gold" onClick={placeBet} disabled={!isGameActive}>
          Play
        </button>
        <button className="btn-gold" onClick={handleClearBets}>
          Clear
        </button>
        <div className="total-box">
          Total - {totalPoints} <span>Pts</span>
        </div>
        <button className="btn-gold" onClick={openResults}>
          Result
        </button>

        <div className="more-draws-text">
          <span>More Draws</span>
          <input
            type="number"
            min="1"
            max="10"
            value={moreDraws}
            onChange={(e) => {
              let val = Number(e.target.value);
              if (val > 10) val = 10;
              if (val < 1) val = 1;
              setMoreDraws(val);
            }}
            disabled={!isGameActive}
          />
          <button className="btn-gold" onClick={placeMultiBet} disabled={!isGameActive}>
            Play Next
          </button>
        </div>
      </div>
      
      {showResultPopup && (
        <div
          className="result-modal"
          onClick={() => setShowResultPopup(false)}
        >
          <div
            className="result-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Results</h3>
              <button onClick={() => setShowResultPopup(false)}>✖</button>
            </div>

            <div className="filter-row">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <button onClick={fetchResults}>Apply</button>
            </div>

            <div className="result-grid modal-grid">
              {[...resultList]
                .sort((a, b) => new Date(a.endTime) - new Date(b.endTime))
                .map((draw, i) => {
                  const card = draw?.result?.card;
                  if (!card) return null;

                  const [rank, suit] = card.split("-");

                  return (
                    <div className="result-box" key={i}>
                      <div className="result-circle">
                        {rank}
                        <img src={`/img/cards/${suit}.png`} alt="" />
                      </div>

                      <div className="result-time">
                        {new Date(draw.endTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
      
      {/* ✅ ADD THIS RIGHT HERE */}
      {showMultiplier && multiplierType && (
        <MultiplierAnimation type={multiplierType} />
      )}
      
    </section>
  );
}